import { render, staticRenderFns } from "./FormTableLabel.vue?vue&type=template&id=5f40f0da&scoped=true&"
import script from "./FormTableLabel.vue?vue&type=script&lang=js&"
export * from "./FormTableLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormTableLabel.vue?vue&type=style&index=0&id=5f40f0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f40f0da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f40f0da')) {
      api.createRecord('5f40f0da', component.options)
    } else {
      api.reload('5f40f0da', component.options)
    }
    module.hot.accept("./FormTableLabel.vue?vue&type=template&id=5f40f0da&scoped=true&", function () {
      api.rerender('5f40f0da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormTableLabel.vue"
export default component.exports